import React, { useState } from 'react';
import { Modal } from "antd";
import { EyeOutlined } from '@ant-design/icons';

interface ImageViewerProps {
    url: string;
    width?: number;
    height?: number;
    alt?: string;
}

const ImageViewer = ({ url, width = 80, height = 60, alt = "image" }: ImageViewerProps) => {
    const [previewVisible, setPreviewVisible] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const handlePreview = () => {
        setPreviewVisible(true);
    };

    return (
        <>
            <div 
                style={{
                    position: 'relative',
                    width: `${width}px`,
                    height: `${height}px`,
                    borderRadius: '8px',
                    overflow: 'hidden',
                    cursor: 'pointer',
                    border: '1px solid #d9d9d9',
                    background: '#f5f5f5'
                }}
                onClick={handlePreview}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <img 
                    src={url} 
                    alt={alt}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                    }}
                />
                
                {/* View icon overlay */}
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        color: 'white',
                        fontSize: '16px',
                        textShadow: '0 2px 4px rgba(0,0,0,0.5)',
                        transition: 'all 0.3s ease',
                        opacity: isHovered ? 1 : 0
                    }}
                >
                    <EyeOutlined  />
                </div>

                {/* Hover overlay */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(0,0,0,0.3)',
                        opacity: isHovered ? 1 : 0,
                        transition: 'opacity 0.3s ease'
                    }}
                />
            </div>

            <Modal 
                open={previewVisible} 
                footer={null} 
                onCancel={() => setPreviewVisible(false)}
                width="80%"
                centered
                style={{ maxWidth: '800px' }}
            >
                <img 
                    style={{ 
                        width: '100%', 
                        maxHeight: '70vh',
                        borderRadius: '8px',
                        objectFit: 'contain'
                    }} 
                    src={url} 
                    alt={alt}
                />
            </Modal>
        </>
    );
};

export default ImageViewer; 